import { Box, Grid, Typography, Divider, Card, CardContent, List, ListItem, ListItemText, Button } from "@mui/material";
import React from "react";
import { AnalyticsPieChart } from "./AnalyticsPieChart";
import _ from "lodash";
import moment from "moment";

export const CandidateAnalytics = ({ jobsApplied, jobsSaved, jobsViewed, isQual = false }) => {

    const getBackGroundColor = (index) => {
      if (jobsApplied.lastItemsStatus[index].unsuccessful){
        return "#AC693B"
      } else {
        return "#87D190";
      }
    }

    const getTextForButton = (index) => {
      if (!isQual){
        if (jobsApplied.lastItemsStatus[index].started){
          return "Started";
        }
        if (jobsApplied.lastItemsStatus[index].interviewed){
          return "Interviewed";
        }
        if (jobsApplied.lastItemsStatus[index].unsuccessful){
          return "Interviewed";
        }
        return "Applied";
      } else {
        if (jobsApplied.lastItemsStatus[index].started){
          return "Enrolled"
        }
        if (jobsApplied.lastItemsStatus[index].interviewed){
          return "Accepted"
        }
        if (jobsApplied.lastItemsStatus[index].unsuccessful){
          return "Accepted";
        }
        return "Applied";
      }
    }

    let arr = [];
    _.each(jobsViewed.chart, (index, key) => {
      arr.push({name: key, value: index});
    });
    let orderBy = _.orderBy(arr, "value", "desc");
    let assoArrChart = {};
    _.each(orderBy.slice(0, 10), (index) => {
      assoArrChart[index.name] = index.value;
    });


    const momentDate = (unix) => {
      return moment.unix(unix / 1000).format("DD/MM/YYYY");
    }


    return (
      <>
        {jobsViewed.count > 0 && (
          <Grid
            container
            direction="row"
            spacing={0}
            justify="center"
            alignItems="flex-start"
            style={{ marginTop: 20 }}
          >
            <Grid item size={{xs:6}}>
              <Typography variant="h5" style={{fontSize:14, textAlign: "center"}}>Top 10 Viewed Jobs By Occupation</Typography>
              <AnalyticsPieChart chartData={assoArrChart} />
            </Grid>
            <Grid item size={{xs:6}}>
            <Typography variant="h5" style={{fontSize:14, textAlign: "center"}}>Top Jobs By Sector</Typography>
              <AnalyticsPieChart chartData={jobsViewed.tierChart} />
            </Grid>
          </Grid>
        )}

        <Grid
          container
          direction="row"
          spacing={2}
          justify="center"
          alignItems="flex-start"
          style={{ marginTop: 20 }}
        >
          <Grid item size={{xs:4}}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="textSecondary"
                  gutterBottom
                >
                  {isQual ? "Qualifications Viewed" : "Jobs Viewed"}
                </Typography>
                <Typography variant="h6" component="h2">
                  {isQual ? "Total Qualifications Viewed" : "Total Jobs Viewed"}
                  <Box component="span" sx={{ textAlign: "right", fontWeight: 600, color: "primary.main", float: "right" }}>
                    {jobsViewed.count}
                  </Box>
                </Typography>
              </CardContent>
              <Divider />

              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="textSecondary"
                  gutterBottom
                >
                  {isQual
                    ? "Last 5 Qualifications Viewed"
                    : "Last 5 Jobs Viewed"}
                </Typography>

                {isQual &&
                  <List dense={true}>
                  {jobsViewed.lastItems.slice(0, 5).map((item,index) => (
                    <ListItem key={"jv_" + item} style={{ paddingLeft: 0 }}>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
                }


                {!isQual &&
                    <List dense={true}>
                    {jobsViewed.lastItems.slice(0, 5).map((item,index) => (
                      <ListItem key={"jv_" + item} style={{ paddingLeft: 0 }}>
                        <ListItemText primary={item+" - "+momentDate(jobsViewed.lastItemsCreatedAt[index])} />
                      </ListItem>
                    ))}
                  </List>
                }
              </CardContent>
            </Card>
          </Grid>
          <Grid item size={{xs:4}}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="textSecondary"
                  gutterBottom
                >
                  {isQual ? "Qualifications Saved" : "Jobs Saved"}
                </Typography>
                <Typography variant="h5" component="h2">
                  {isQual ? "Total Qualifications Saved" : "Total Jobs Saved"}
                  <Box component="span" sx={{ textAlign: "right", fontWeight: 600, color: "primary.main", float: "right" }}>{jobsSaved.count}</Box>
                </Typography>
              </CardContent>
              <Divider />
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="textSecondary"
                  gutterBottom
                >
                  {isQual ? "Last 5 Qualifications Saved" : "Last 5 Jobs Saved"}
                </Typography>

                {isQual &&
                    <List dense={true}>
                    {jobsSaved.lastItems.slice(0, 5).map((item, index) => (
                      <ListItem key={"js_" + item} style={{ paddingLeft: 0 }}>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                }

                {!isQual &&
                  <List dense={true}>
                    {jobsSaved.lastItems.slice(0, 5).map((item, index) => (
                      <ListItem key={"js_" + item} style={{ paddingLeft: 0 }}>
                        <ListItemText primary={item+" - "+momentDate(jobsSaved.lastItemsCreatedAt[index])} />
                      </ListItem>
                    ))}
                  </List>
                }
              </CardContent>
            </Card>
          </Grid>
          <Grid item size={{xs:4}}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="textSecondary"
                  gutterBottom
                >
                  
                  {isQual ? "Qualifications Inquiries" : "Jobs Applied"}
                </Typography>
                <Typography variant="h5" component="h2">
                {isQual ? "Total Qualifications Inquiries" : "Total Jobs Applied"}
                  <Box component="span" sx={{ textAlign: "right", fontWeight: 600, color: "primary.main", float: "right" }}>
                    {jobsApplied.count}
                  </Box>
                </Typography>
              </CardContent>
              <Divider />
              <CardContent>
                <Typography
                  sx={{ fontSize: 14 }}
                  color="textSecondary"
                  gutterBottom
                >
                  {isQual ? "Last 5 Qualifications Inquiries" : "Last 5 Jobs Applied"}
                </Typography>

                {isQual && 
                    <List dense={true}>
                    {jobsApplied.lastItems.slice(0, 5).map((item, index) => (
                      <ListItem key={"ja_" + item} style={{ paddingLeft: 0 }}>
                        <Grid alignItems="center" container spacing={3}>
                        <Grid item size={{xs:12}} sm={12} md={8}>
                          <ListItemText sx={{ mt: 1.25 }} primary={item} />
                        </Grid>
                        <Grid item size={{xs:12}} sm={12} md={4}>
                          <Button variant="contained" style={{color: "#F9F9F9", backgroundColor: getBackGroundColor(index)}}> {getTextForButton(index)}</Button>
                        </Grid>
                        <Divider sx={{ width: '100%', mb: 1.25 }} />
                        </Grid>
                      </ListItem>
                    ))}
                  </List>
                }

                {!isQual &&
                  <List dense={true}>
                  {jobsApplied.lastItems.slice(0, 5).map((item, index) => (
                    <ListItem key={"ja_" + item} style={{ paddingLeft: 0 }}>
                      <Grid alignItems="center" container spacing={3}>
                      <Grid item size={{xs:12}} sm={12} md={8}>
                        <ListItemText sx={{ mt: 1.25 }} primary={item+" - "+momentDate(jobsApplied.lastItemsCreatedAt[index])} />
                      </Grid>
                      <Grid item size={{xs:12}} sm={12} md={4}>
                        <Button variant="contained" style={{color: "#F9F9F9", backgroundColor: getBackGroundColor(index)}}> {getTextForButton(index)}</Button>
                      </Grid>
                      <Divider sx={{ width: '100%', mb: 1.25 }} />
                      </Grid>
                    </ListItem>
                  ))}
                </List>
                }
                
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </>
    );
};
